module.exports = __webpack_public_path__ + "static/media/bg-image-6.ee554567.jpg";